import localeText from "../../../../locale";

// Periodo (de/ate) das listas de vendas e de provisao; aplica so no botao
const PeriodFilter = ({ value, onChange, onApply, loading, children }) => (
  <form
    className="admin-scp__period"
    onSubmit={(e) => {
      e.preventDefault();
      onApply();
    }}
  >
    <label>
      {localeText("adminChannelFrom")}
      <input
        type="date"
        className="admin-scp__input"
        value={value.from}
        max={value.to}
        onChange={(e) => onChange({ ...value, from: e.target.value })}
        required
      />
    </label>
    <label>
      {localeText("adminChannelTo")}
      <input
        type="date"
        className="admin-scp__input"
        value={value.to}
        min={value.from}
        onChange={(e) => onChange({ ...value, to: e.target.value })}
        required
      />
    </label>
    <button type="submit" className="admin-btn" disabled={loading}>
      {localeText("adminChannelApply")}
    </button>
    {children}
  </form>
);

export default PeriodFilter;
